var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-button"
  }, [_c('img', {
    staticClass: "wallet",
    attrs: {
      "src": require("../assets/wallet_icon.svg"),
      "width": "30",
      "height": "30",
      "alt": "wallet"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "price hidden",
    class: {
      showPrice: _vm.isShow(2)
    }
  }, [_vm._v("45 000")]), _vm._v(" "), _c('span', {
    staticClass: "price hidden",
    class: {
      showPrice: _vm.isShow(3)
    }
  }, [_vm._v("45 000")]), _vm._v(" "), _c('span', {
    staticClass: "price hidden",
    class: {
      showPrice: _vm.isShow(4)
    }
  }, [_vm._v("45 000")]), _vm._v(" "), _c('img', {
    staticClass: "rub",
    attrs: {
      "src": require("../assets/rub.svg"),
      "width": "14",
      "height": "16",
      "alt": "wallet"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bdf90a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buyButton.vue
// module id = TCgf
// module chunks = 0